import React from 'react';
import { Card } from './Card';
import { InteractionsIcon } from '../icons/InteractionsIcon';
import { Diff } from '../Diff';
import { AttentionIcon } from '../icons/AttentionIcon';
import { getDiff } from '../../model/Diff';

const InteractionsMetricsCard = ({ count, previousCount, time, previousTime }: Props) => {
  return (
    <Card>
      <div className="card-body">
        <h5 className="card-title mb-4">Interactions core metrics</h5>
        <div className="row align-items-center text-dark mb-4">
          <div className="col-6 d-flex align-items-center">
            <InteractionsIcon />
            <span className="ms-3 text-black">Interactions</span>
          </div>
          <div className="col-6 d-flex align-items-center justify-content-end">
            <span className="me-2 fs-5">{count}</span>
            <Diff value={getDiff(count, previousCount)} />
          </div>
        </div>
        <div className="row align-items-center text-dark">
          <div className="col-6 d-flex align-items-center">
            <AttentionIcon />
            <span className="ms-3 text-black">Avg. time</span>
          </div>
          <div className="col-6 d-flex align-items-center justify-content-end">
            <span className="me-2 fs-5">{time.toFixed(1) + 's'}</span>
            <Diff value={getDiff(time, previousTime)} />
          </div>
        </div>
      </div>
    </Card>);
}

interface Props {
  count: number,
  time: number,
  previousCount: number,
  previousTime: number
}

export { InteractionsMetricsCard };